<section class="container py-3">
  <div class="row m-0 border-bottom border-2 mb-3 pb-2">
    <label class="col-3 ">
      <span>عنوان رویداد</span>
      <input name="title" [(ngModel)]="newAnnotation.Title" />
    </label>
    <label class="col-3">
      <span>توضیحات</span>
      <textarea name="description" [(ngModel)]="newAnnotation.Description"></textarea>
    </label>
    <label class="col-3">
      <span>تاریخ</span>
      <app-calendar name="effective-time" [(ngModel)]="newAnnotation.EffectiveTime"></app-calendar>
    </label>
    <div class="col-3 d-flex align-items-center">
      <button class="btn btn-blue" (click)="save(newAnnotation)">ایجاد</button>
    </div>
  </div>
  <ng-container *ngFor="let annotation of annotations">
    <div class="row">
      <div class="col-3">{{annotation.Title}}</div>
      <div class="col-3">{{annotation.Description}}</div>
      <div class="col-3">{{annotation.EffectiveTime|pdate}}</div>
      <div class="col-3 text-center">
        <button class="btn" (confirm)="delete(annotation)">حذف</button>
      </div>
    </div>
    <hr />
  </ng-container>
</section>